import { ModalWizardStep } from "components/ModalWizard/ModalWizard";

export function getCurrentStepIndex<CompletedWizardData>(
	steps: ModalWizardStep<CompletedWizardData>[],
	currentStepKey: string
) {
	const index = steps.findIndex(step => step.key === currentStepKey);
	return index === -1 ? 0 : index;
}
